import type { AxiosError, AxiosResponse } from 'axios'
import type { Offer, OfferPackage, OfferVehicle } from 'BrokerTsLib/src/dtos'
import { createContext, useContext, useEffect } from 'react'
import type { QueryObserverResult, RefetchOptions, RefetchQueryFilters } from 'react-query'
import { useGetOffer } from '../../hooks/useOffer'
import { insuranceParamsContext } from '../../layouts/Wizard'

export type insurerOfferContextProps = {
  isLoading: boolean
  offerId?: number | null
  offer?: Offer | OfferVehicle | OfferPackage
  refetch: <TPageData>(options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined) => Promise<QueryObserverResult<AxiosResponse<Offer, any>, any>>
  error?: AxiosError<any> | null
}

export const insurerOfferContext = createContext<insurerOfferContextProps>({} as insurerOfferContextProps)

export const WithOffer = <T extends object>(WrappedComponent: React.ComponentType<T>) => {
  const NewComponent = (props: T) => {
    const { insuranceParams, isLoadingData: isLoadingInsuranceParams } = useContext(insuranceParamsContext)
    const offerId = insuranceParams?.generalParams.selectedOfferId
    const { isLoading, isFetching, data, refetch, error } = useGetOffer(offerId ?? 0, { enabled: false, cacheTime: 0, })

    useEffect(() => {
      if (offerId)
        refetch()
    }, [offerId])

    return (
      <>
        <insurerOfferContext.Provider value={{
          isLoading: isLoadingInsuranceParams || isLoading || isFetching,
          offerId,
          offer: data?.data,
          refetch,
          error
        }}>
          <WrappedComponent {...props} />
        </insurerOfferContext.Provider>
      </>
    )
  }

  return NewComponent
}